export const Dot = () => (
  <div className="w-1 h-1 bg-dashboardtext rounded-full mx-3"></div>
)
